import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { articleAPI } from '../services/api';
import './RelatedArticles.css';

function RelatedArticles({ articleId }) {
  const [relatedArticles, setRelatedArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRelated = async () => {
      try {
        const response = await articleAPI.getRecommendations(articleId, { limit: 3 });
        // API returns { count, recommendations: [...] }
        const data = response.data;
        const articles = Array.isArray(data) ? data : (data?.recommendations || []);
        setRelatedArticles(articles);
      } catch (error) {
        console.error('Error fetching related articles:', error);
        setRelatedArticles([]);
      } finally {
        setLoading(false);
      }
    };

    if (articleId) {
      fetchRelated();
    }
  }, [articleId]);

  const getCategoryColor = (category) => {
    const colors = {
      crypto: '#f39c12',
      ai: '#3498db',
      politics: '#e74c3c'
    };
    return colors[category] || '#666';
  };

  if (loading || relatedArticles.length === 0) {
    return null;
  }

  return (
    <div className="related-grid">
      {relatedArticles.map(article => (
        <Link
          key={article.id}
          to={`/article/${article.id}`}
          className="related-card"
        >
          <img
            src={article.image_url || 'https://via.placeholder.com/300x180?text=News'}
            alt={article.title}
            className="related-image"
            onError={(e) => e.target.src = 'https://via.placeholder.com/300x180?text=News'}
          />
          <div className="related-content">
            <span
              className="category-badge-tiny"
              style={{ backgroundColor: getCategoryColor(article.category) }}
            >
              {article.category?.toUpperCase()}
            </span>
            <h3 className="related-card-title">{article.title}</h3>
            <p className="related-summary">
              {(article.ai_summary || article.summary || '').substring(0, 100)}...
            </p>
          </div>
        </Link>
      ))}
    </div>
  );
}

export default RelatedArticles;